module.exports = __webpack_public_path__ + "img/55.168cf6f6.jpg";